import { Route, Routes } from "react-router-dom";
import { ArtworkCollectionCreatePage } from "./pages/collection/create";
import { ArtworkPrintingTechniqueCretePage } from "./pages/printing-technique/create";
import { CreateArtworkCollectionProvider } from "./context/collection/create/CreateArtworkCollectionContext";
import { CreatePrintingTechniqueProvider } from "./context/printingTechnique/create/CreatePrintingTechniqueContext";
import { ApprovalArtwork } from "./pages/approvals";
import { SearchArtwork } from "./pages/search";
import { PageableTableProvider } from "../../context/PageableTableContext";

const ArtworkRoutes = () => (
  <Routes>
    <Route
      path="/"
      element={
        <PageableTableProvider>
          <SearchArtwork />
        </PageableTableProvider>
      }
    />
    <Route path="/approvals" element={<ApprovalArtwork />} />
    {/*<Route path="/" element={<Index />}>*/}
    <Route path="collections">
      <Route
        path="create"
        element={
          <CreateArtworkCollectionProvider>
            <ArtworkCollectionCreatePage title={"Create New Collection"} />
          </CreateArtworkCollectionProvider>
        }
      />
      <Route
        path="detail/:id"
        element={
          <CreateArtworkCollectionProvider>
            <ArtworkCollectionCreatePage title={"Collection Detail"} />
          </CreateArtworkCollectionProvider>
        }
      />
    </Route>

    <Route path="printing-technique">
      <Route
        path="create"
        element={
          <CreatePrintingTechniqueProvider>
            <ArtworkPrintingTechniqueCretePage />
          </CreatePrintingTechniqueProvider>
        }
      />
      <Route
        path="detail/:id"
        element={
          <CreatePrintingTechniqueProvider>
            <ArtworkPrintingTechniqueCretePage />
          </CreatePrintingTechniqueProvider>
        }
      />
    </Route>
    {/*</Route>*/}
  </Routes>
);
export default ArtworkRoutes;
